module.exports = __webpack_public_path__ + "static/media/antelope.f472e090.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/about/antelope.png
// module id = 308
// module chunks = 0